<template>
		<router-link class="a-cta" :to="to" :style="{paddingLeft: sidePadding, paddingRight: sidePadding}"><slot></slot></router-link>
</template>
<script>
export default {
	props: {
		to: {
			type: String,
			default: '/'
		},
		sidePadding: {
			type: String,
			default: '20px'
		}
	}
}
</script>
<style lang="scss" scoped>
.a-cta {
	display: inline-block;
	padding: 20px;
	width: auto;
	text-align: center;
	background: $red;
	color: $white;
	font-weight: bold;
	text-decoration: none;
	text-transform: uppercase;
}
</style>
